import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=463ffcb0&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=463ffcb0&scoped=true&lang=css&"
import style1 from "./Index.vue?vue&type=style&index=1&id=463ffcb0&scoped=true&lang=css&"
import style2 from "./Index.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ffcb0",
  null
  
)

export default component.exports
import {QPageSticky,QFooter,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPageSticky,QFooter,QField})
